import * as ROUTES from '../backend-routes'
import { executePost, executePatch } from '../requests/axios'

export const registerUser = function (payload, onSuccess, onError) {
  executePost(ROUTES.REGISTER.PATH_REGISTER_USER, payload, onSuccess, onError)
}

export const confirmUsername = function (uid, payload, onSuccess, onError) {
  executePost(ROUTES.REGISTER.PATH_CONFIRM_USERNAME + uid, payload, onSuccess, onError)
}

export const confirmProfile = function (uid, payload, onSuccess, onError) {
  executePatch(ROUTES.REGISTER.PATH_CONFIRM_PROFILE + uid, payload, onSuccess, onError)
}
